import { Link } from 'react-router-dom';
import React from 'react';

const HeroSectionWithBrightButtons = () => {
  const services = [
    {
      title: 'Badeværelser',

      link: '/kontakt',
    },
    {
      title: 'Flisearbejde',

      link: '/galleri',
    },
    {
      title: 'Projekter',

      link: '/galleri',
    },
  ];

  return (
    <section
  className="relative w-full flex flex-col items-center justify-center text-center text-white overflow-hidden"
  style={{
    minHeight: '90vh',
    backgroundImage: "url('/media/billeder/fliser/IMG_0047.jpeg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    transform: 'translateY(-30px)', // Push everything up 30px
  }}
>
  {/* Wrapper to crop bottom 30px */}
  <div className="absolute inset-0 overflow-hidden" style={{ paddingBottom: '30px' }}>
    {/* Dark overlay */}
    <div className="absolute inset-0 bg-black/40"></div>
  </div>

  {/* Hero Text */}
  <div className="relative max-w-3xl p-6 md:p-12 -translate-y-7">
    <p
      className="text-base md:text-xl leading-relaxed font-bold"
      style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8)' }}
    >
      Jeg er din lokale ekspert inden for alt murerarbejde
      <br />
      – med særligt fokus på badeværelser og renovering.
      <br />
      Hos mig er kvalitet og godt håndværk altid i højsædet!
      <br />
      Har du et projekt i tankerne? Kontakt mig i dag, og få et uforpligtende tilbud.
      <br />
      Sammen skaber vi løsninger, der holder 💪
    </p>
  </div>

  {/* Bright Service Buttons */}
  <div className="relative mt-6 flex flex-wrap justify-center gap-4 px-4 max-w-5xl w-full z-10 -translate-y-7">
    {services.map((service, index) => (
      <Link key={index} to={service.link}>
        <button className="relative px-6 py-3 rounded-full font-bold overflow-hidden shadow-xl transition-all duration-300 transform hover:scale-105 bg-white/20 hover:bg-white/30">
          <span className="relative z-10">{service.title}</span>
        </button>
      </Link>
    ))}
  </div>
</section>

  );
};

export default HeroSectionWithBrightButtons;
